const e = "styles-module__subMenuContainer___WVXMX", s = "styles-module__itemRowClassName___d8WRc", n = "styles-module__accountIcon___h6k5H", o = "styles-module__newCaseWrapper___GhRk6", _ = "styles-module__newCaseIconHover___TmnYS", a = "styles-module__newCaseIcon___2Da09", t = {
  subMenuContainer: e,
  itemRowClassName: s,
  accountIcon: n,
  newCaseWrapper: o,
  newCaseIconHover: _,
  newCaseIcon: a
};
export {
  n as accountIcon,
  t as default,
  s as itemRowClassName,
  a as newCaseIcon,
  _ as newCaseIconHover,
  o as newCaseWrapper,
  e as subMenuContainer
};
